// Author YuJiaBei
// Date 2022-04-22 16:27:57

import * as model from "@/model/em/inspection/InspectionWorkOrderModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.InspectionWorkOrder(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_INSPECTION_URL,
        callbackApi: process.env.VUE_APP_EM_INSPECTION_URL + '/inspectionWorkOrder/workflow/complete-feedback',
        processDefinitionKey: "em_inspection_work_order",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
